// @flow

export const breakWord = {
  wordWrap: 'break-word',
  // Allows FF to break within a flex item
  minWidth: 0,
}



// WEBPACK FOOTER //
// ./src/style/wordWrap.js